import Logout from "@/components/partials/logout"
import Sidebar from "@/components/partials/sidebar"
import Topbar from "@/components/partials/topbar"
import { Helmet } from "react-helmet"

export default function Main({ children, title = "", headerTitle = "", showBackButton = false }) {
    return (
        <>
            <Helmet>
                <title>{`${title} – ${process.env.REACT_APP_NAME}`}</title>
            </Helmet>
            <Sidebar />
            <div className="flex justify-center min-h-screen pb-8">
                <div className="flex flex-col w-full max-w-2xl">
                    <Topbar title={headerTitle} showBackButton={showBackButton} />
                    <div className="w-full overflow-x-hidden bg-white border overscroll-y-auto rounded-3xl">
                        <div className="flex flex-col flex-grow">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <Logout />
        </>
    )
}